import { find, pickBy } from 'lodash';

const hasAmenities = (group) => !!find(group.items, (amenity) => amenity.hasAttribute || amenity.showAlways);

export const withAmenities = (amenityGroup) => pickBy(amenityGroup, hasAmenities);
